// src/config.js - SurveyPro
// Works for local development, production web, and mobile app

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const isLocalNetwork = window.location.hostname.startsWith('192.168.');
const isCapacitor = window.Capacitor?.isNativePlatform?.() || false;

let API_BASE;

if (isCapacitor) {
  // Mobile app - always use production server
  API_BASE = 'https://app.northgeorgiasurveying.com';
} else if (isLocalhost || isLocalNetwork) {
  // Local development
  API_BASE = 'http://localhost:5000';
} else {
  // Production web - use relative URL
  API_BASE = '';
}

// Largest file the UI will try to upload. Keep in step with MAX_UPLOAD_MB in backend/app.py
// and client_max_body_size in the nginx site config — the smallest of the three wins, and
// when this one is the smallest the request never leaves the browser, so nothing is logged
// server-side to explain the failure.
export const MAX_UPLOAD_BYTES = 150 * 1024 * 1024;

export const API_URL = `${API_BASE}/api`;
export const API_BASE_URL = API_BASE;

export { API_BASE };
export default API_URL;